// So that we can make `createdAt` and `context` as optional in the ReportFilterState
type PartialRecord<K extends keyof any, T> = {
    [P in K]?: T;
};

export interface ReportFilterState extends PartialRecord<string, ReportFilter> {
    status?: any;
    createdAt?: {
        operator: ReportFilterOperator;
        value: string[] | number[];
    };
    context?: {
        operator: ReportFilterOperator.EQ;
        value: "report" | "questionnaire" | "memberships" | "ware_gross_sales" | "ware";
    };
    expand?: any;
}

export type ReportFilterValue = number | string | boolean | null;

export interface ReportFilter {
    operator: ReportFilterOperator;
    value: ReportFilterValue | ReportFilterValue[];
    rangeName?: string;
}

export enum ReportFilterOperator {
    EQ = "equals",
    NE = "notEqual",
    GT = "gt",
    GTE = "gte",
    LT = "lt",
    LTE = "lte",
    IN = "in",
    NIN = "nin",
    RANGE = "range",
    PERIOD = "period",
    STARTS_WITH = "startsWith",
    ENDS_WITH = "endsWith",
    CONTAINS = "contains",
    DOES_NOT_CONTAIN = "doesNotContain",
    EXISTS = "exists",
}

export const ReportFilterOperatorCopy = {
    [ReportFilterOperator.EQ]: "Equal to",
    // [ReportFilterOperator.NE]: "Not equal to",
    [ReportFilterOperator.GT]: "Greater than",
    [ReportFilterOperator.GTE]: "Greater than or equal to",
    [ReportFilterOperator.LT]: "Less than",
    [ReportFilterOperator.LTE]: "Less than or equal to",
    // TODO: Add other
};

export const TextFilterParams = {
    maxNumConditions: 1,
    filterOptions: [
        {
            displayKey: ReportFilterOperator.CONTAINS,
            displayName: "Contains",
            predicate: () => true,
        },
        {
            displayKey: ReportFilterOperator.EQ,
            displayName: "Equals",
            predicate: () => true,
        },
        {
            displayKey: ReportFilterOperator.STARTS_WITH,
            displayName: "Starts With",
            predicate: () => true,
        },
    ],
    defaultOption: ReportFilterOperator.CONTAINS,
};
